import React, { useEffect, useState} from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer} from 'recharts';
import "./Dashboard.css";
import backgroundImage from "../../assets/PathianCurves.png";
import { Grid as SemanticGrid, Dropdown, Dimmer, Loader } from "semantic-ui-react";
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { process } from '@progress/kendo-data-query';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import { useDashboard } from '../../providers/DashboardProvider';
import { useAuth } from '../../providers/AuthenticationProvider';
import {useNavigate} from "react-router";
const WEB_PAGE = 'Dashboard';

var _ = require('lodash');



const BackgroundStyle = {
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  width: "100%",
  minHeight: "70vh",
};


export const Dashboard = () => {
  const [dashboards, setDashboards] = useState([]);
  const [distributors, setDistributors] = useState([]);
  const {getDashboard} = useDashboard();
  const {isSystemAdmin, getUserType, checkAuth} = useAuth();
  const [loading, setLoading] = useState(true);
  const [datakey, setDatakey] = useState(0);
  const today = new Date();
  const [endDate, setEndDate] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date(today.setMonth(today.getMonth()-1)));
  const navigate = useNavigate();

  checkAuth(getUserType(), WEB_PAGE) && navigate('/');

  useEffect(() => {
    setLoading(true);
      getDashboard(startDate,endDate).then((value) => {
        setDistributors(value.distributors);
        setDashboards(value.data);
        setLoading(false);
      });
}, [getDashboard,startDate,endDate]);

function onChangedrop(event,data) {
  if (data.value === "All") {
    setDatakey(0);
  }
  else{
    setDatakey(data.value);
  }
}

const list = [{
  key: "All",
  text: "All",
  value: "All"
}];

distributors.map(dist => (
  list.push({
    key: dist.key,
    text: dist.value,
    value: dist.key
  })
))

if(datakey !== null){
  var data = dashboards;
  data = _.filter(data, function (o) {
    return new Date(o.timestamp) >= new Date(startDate) && new Date(o.timestamp) <= new Date(endDate);
  });

  if (datakey !== 0) {
    data = data.filter(z => z.distributorId === datakey)
  }

  data = data.map(r => ({
    distributorID: r.distributorId,
    timestamp: new Date(r.timestamp).toLocaleDateString(),
    total: r.totalCost
  }));

  data = _.chain(data)
    .groupBy("timestamp")
    .map((value, key) =>
      ({ time: key, total: _.sum(value.map(({ total }) => total)) }))
    .value()
    .sort((a, b) => new Date(b.time) - new Date(a.time))
    .reverse();

}

const ToolBar = ({ style, hidden }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent:"center",
        paddingBottom: "16px",
        visibility: hidden ? "hidden" : "visible",
      }}
    >
      <SemanticDatepicker  name="startDate" value={startDate} format="MM-DD-YYYY" onChange={(event, data) => setStartDate(data.value)}  />
      <SemanticDatepicker  name="endDate" value={endDate} format="MM-DD-YYYY" onChange={(event, data) => setEndDate(data.value)}  />
    </div>
  );
};

const ProposalsTable = () => {
  const [dataState, setDataState] = useState({ skip: 0, take: 10, sort: [] });

  let selection = dashboards;
  if (datakey !== 0) {
    selection = selection.filter(das => das.distributorId === datakey);
  }
  if (startDate) {
    selection = _.filter(selection, function (o) {
      return new Date(o.timestamp) >= new Date(startDate) && new Date(o.timestamp) <= new Date(endDate);
    });
  }

  const result = process(selection, dataState);

  return (
    <div style={{ position: 'relative' }}>
      <Dimmer active={loading} inverted>
        <Loader />
      </Dimmer>
      <Grid
        data={result.data}
        total={result.total}
        skip={dataState.skip}
        take={dataState.take}
        pageable={true}
        sortable={true}
        sort={dataState.sort}
        onDataStateChange={e => setDataState(e.dataState)}
        onRowClick={e => setDatakey(e.dataItem.distributorId)}
      >
        <Column field="companyName" title="Company" />
        <Column field="name" title="Name" />
        <Column
          field="totalCost"
          title="Total"
          width={130}
          cell={props => (
            <td style={{ textAlign: 'right' }}>
              {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencyDisplay: 'narrowSymbol' }).format(props.dataItem.totalCost)}
            </td>
          )}
        />
        <Column
          field="timestamp"
          title="Date"
          width={120}
          cell={props => (
            <td>{new Date(props.dataItem.timestamp).toLocaleDateString("en-US")}</td>
          )}
        />
      </Grid>
    </div>
  );
}

const Chart = () =>{

  return(
    <div
      style={{ width: 550, height: 400, backgroundColor: 'white' }}
      margin={{ top: 15, right: 0, left: 5, bottom: 5 }}
    >
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={data}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="time" label={{ value: "Date", position: "Bottom", dy: 12}}/>
                  <YAxis  tickFormatter={tick => {
                              return "$"+new Intl.NumberFormat("en-US", {notation: "compact",compactDisplay: "short"}).format(tick)}
                            }/>
                  <Tooltip />
                  <Legend verticalAlign="top" />
                  <Line
                    type="monotone"
                    dataKey="total"
                    stroke="#82ca9d"
                    strokeWidth={2}
                    label={false}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
  );
}


  return (
    <div className="dashboard-container" style={BackgroundStyle}>
      <SemanticGrid
        columns={3}
        style={{
          paddingTop: "32px",
          width: "100%",
        }}
      >
        <SemanticGrid.Row>
          <SemanticGrid.Column width={3}>
            <h1>Overview</h1>
          </SemanticGrid.Column>

          <SemanticGrid.Column width={5}>
            {
              isSystemAdmin() ?
              <div>
                <Dropdown
                  placeholder='Select Distributor'
                  fluid
                  selection
                  options={list}
                  onChange={onChangedrop}
                  defaultValue={'All'}
                />
              </div>
              : null
            }
          </SemanticGrid.Column>
          <SemanticGrid.Column width={8}>
            <ToolBar />
          </SemanticGrid.Column>

        </SemanticGrid.Row>

        <SemanticGrid.Row>
          <SemanticGrid.Column floated='left' width={8}>

            <ProposalsTable />

          </SemanticGrid.Column>
          <SemanticGrid.Column floated='right' width={8}>

            <Chart />

          </SemanticGrid.Column>

        </SemanticGrid.Row>

      </SemanticGrid>
    </div>
  );
};
